var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2183 6.41111L13.9575 5.67185L12.3281 4.04243L11.5889 4.78169L13.2183 6.41111ZM12.2854 7.34403L10.6559 5.7146L4.56054 11.81L4.18552 13.8144L6.18996 13.4394L12.2854 7.34403ZM14.9298 4.77834C15.4233 5.27181 15.4233 6.07189 14.9298 6.56537L6.97847 14.5167C6.8844 14.6108 6.76409 14.6742 6.63333 14.6987L3.48125 15.2884C3.02545 15.3737 2.62624 14.9745 2.71152 14.5187L3.30126 11.3666C3.32573 11.2359 3.38916 11.1156 3.48322 11.0215L11.4346 3.07012C11.9281 2.57664 12.7281 2.57664 13.2216 3.07012L14.9298 4.77834ZM14.6434 15.3H9.32496C8.44951 15.3 8.44951 13.9737 9.32496 13.9737H14.6434C15.5188 13.9737 15.5188 15.3 14.6434 15.3Z",
    fill: "#454551"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.8548e5cdf8a03cf6f4657f8bb3dc4544.svg";
export { ForwardRef as ReactComponent };